import {useEffect, useState} from "react";
import associateServices from "../../../services";
import {useSelector} from "react-redux";
import HomepageCasinoGroupItem from "./item";
import LazyLoad from 'react-lazyload';

const generalGroups = {}
const SlotLobbyGroups = () => {
    const {activeLanguage} = useSelector(state => state.globalReducer)

    const [groups, setGroups] = useState([])

    useEffect(() => {
        // todo get homepage groups !

        if (generalGroups[activeLanguage.key]) {
            setGroups(generalGroups[activeLanguage.key])
        } else
            associateServices.getSlotLobbyGameGroups({
                language: activeLanguage?.key,
            }).then(res => {
                setGroups(res?.data || [])
                generalGroups[activeLanguage.key] = res?.data || null
            })
    }, [activeLanguage?.key])


    return (
        <>
            {
                groups?.map(group =>
                    <HomepageCasinoGroupItem
                        key={group?.id}
                        path={group?.slug} image={group?.image}
                        title={group?.title} data={group?.group}/>
                )
            }
        </>
    )

}

export default SlotLobbyGroups
